import React, { useEffect } from 'react';
import '../components/brand/brand.css';
import { Toaster } from '../components/ui/sonner';
import { BrandHeader } from '../components/brand/BrandHeader';
import { BrandHero } from '../components/brand/BrandHero';
import { SegmentTicker } from '../components/brand/SegmentTicker';
import { Manifesto3D } from '../components/brand/Manifesto3D';
import { Method3D } from '../components/brand/Method3D';
import { AboutAnderson } from '../components/brand/AboutAnderson';
import { Segments } from '../components/brand/Segments';
import { RaioXSection } from '../components/brand/RaioXSection';
import { BrandFAQ } from '../components/brand/BrandFAQ';
import { BrandFooter } from '../components/brand/BrandFooter';
import { useDocumentSEO } from '../utils/useDocumentSEO';

export default function BrandHomePage() {
  useDocumentSEO({
    title: 'Anderson Coutinho — Estrategista de Marca e Audiovisual | Foz do Iguaçu',
    description: 'Estratégia de marca, audiovisual e presença digital para empresas que querem ser escolhidas pelo valor, não pelo preço. Peça seu Raio-X da Marca grátis em até 24h.',
    canonical: 'https://www.agenciacoutin.com.br/',
    ogImage: 'https://www.agenciacoutin.com.br/images/anderson-camera.jpg',
  });

  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="br-root min-h-screen" data-testid="brand-home-page">
      <BrandHeader />
      <main>
        <BrandHero />
        <SegmentTicker />
        <Manifesto3D />
        <Method3D />
        <AboutAnderson />
        <Segments />
        <RaioXSection />
        <BrandFAQ />
      </main>
      <BrandFooter />
      <Toaster position="top-center" theme="dark" />
    </div>
  );
}
